<template>
  <!-- 付汇申请-新增 -->
  <div class="paymentApplication">
    <el-form
      :model="dataForm"
      ref="dataForm"
      label-position="top"
      class="dataForm"
      :rules="rules"
    >
      <div v-if="dataForm.paymentAppVo.bizType && bizTypeList.length > 1 && dataForm.paymentAppVo.billType === 1" class="biz-type" @click="editBizType">
        
        <span v-if="dataForm.paymentAppVo.bizType == '01'">
          发票类型：13% 增值税专用发票
        </span>
        <span v-if="dataForm.paymentAppVo.bizType == '02'">
          发票类型：海关税票+6% 服务费发票 
        </span>
        <span v-if="!dataForm.paymentAppVo.bizType" class="is-error"><span style="color:#ff187b;">* </span>选择发票类型 </span>
        <ab-svg name="fankui" v-if="bizTypeList.length > 1" ></ab-svg>
        <!-- 海关税票+6% 服务费发票 -->
      </div>

      <div class="payoutInfo">
        <div class="title">收款信息</div>
        <el-row :gutter="20">
          <el-col :span="16">
            <el-form-item prop="paymentAppVo.revIdDesc">
              <ab-select2
                class="revIdDesc"
                v-model="dataForm.paymentAppVo.revIdDesc"
                url="/bas/client/basSupplier/list"
                :urlData="{ bizType: dataForm.paymentAppVo.bizType, queryFrom: 'payApply' }"
                inputKey="nameOrNumber"
                descKey="name"
                label="收款方"
                required
                :disabled="(['wait', 'import', 'out'].includes(routeQuery.action) && !dataForm.paymentAppVo.disableUnitId)"
                @handleSelect="revSelect"
                @handlerAdd="revAdd"
                ref="revIdDesc"
              ></ab-select2>
            </el-form-item>
          </el-col>

            <el-col :span="8">
                <div class="choose">
                    <el-checkbox v-model="dataForm.paymentAppVo.disableUnitId" label="委托收款"/>
                    <el-checkbox v-if="hasAdvance" v-model="dataForm.paymentAppVo.isAdvance" label="垫资"/>
                </div>
            </el-col>

          <el-col :span="8">
            <el-row class="merge-input">
              <el-col :span="18">
                <el-form-item
                  prop="paymentAppVo.applyAmount"
                  label="收款金额"
                >
                  <el-input
                    v-model="dataForm.paymentAppVo.applyAmount"
                    placeholder="请输入收款金额"
                    class="input-with-select applyAmount-input"
                    :style="{'font-size': dataForm.paymentAppVo.applyAmount ? '30px' : '14px'}"
                    :disabled="this.dataForm.paymentAppPayVoList.length && ['wait', 'import', 'out'].includes(this.routeQuery.action)"
                    @blur="amoutOrRevChange"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="paymentAppVo.applyCurrencyIdDesc"
                  label="　"
                >
                  <ab-select
                    v-model="dataForm.paymentAppVo.applyCurrencyIdDesc"
                    url="/bas/basCurrency/list"
                    placeholder="请选择"
                    :disabled="this.dataForm.paymentAppPayVoList.length && ['wait', 'import', 'out'].includes(this.routeQuery.action)"
                    @handleSelect="applyCurrencySelect"
                  ></ab-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="8">
            <div class="collectionMoneyDelete">
              <div class="symbol1">
                <el-icon>
                  <CloseBold />
                </el-icon>
              </div>
              <div class="rate" ref="settleRate">
                <span>汇率</span>
                <div class="number">{{ dataForm.paymentAppVo.settleRate }}</div>
              </div>
              <div class="symbol2">=</div>
              <div class="zong">
                <span>{{ dataForm.paymentAppVo.settleCurrencyIdDesc }}</span>
                <div class="number">{{ settlementAmount }}<span>({{ dataForm.paymentAppVo.settleCurrencyNumber }})</span></div>
              </div>
            </div>
          </el-col>
        
            <el-col :span="8">
                <div class="collectionMoneyDelete">
                    <div class="zong">
                        <span>手续费</span>
                        <div class="number">{{dataForm.paymentAppVo.chargesBearerCny || 0}}<span>(CNY)</span></div>
                    </div>
                </div>
            </el-col>

          <el-col :span="8">
            <el-form-item
              prop="paymentAppVo.revBankIdDesc"
              label="收款银行"
            >
              <ab-select
                  :list="bankList"
                  placeholder="请选择"
                  prefix
                  inputKey="bankName"
                  v-model="dataForm.paymentAppVo.revBankIdDesc"
                  @handleSelect="revBankChange"
              >
                <template #prefix>
                  <span class="addBank">
                    <ab-svg name="add" @click.stop="revBankAdd"></ab-svg>
                  </span>
                </template>
                <template #content="scope">
                  <div v-if="scope.item.bank" class="pledging-bank-item">
                    <div>
                      <span>{{ scope.item.bankName }} <el-tag class="ml-2" type="warning" v-if="scope.item.isDefault">默认</el-tag></span>
                    </div>
                    <div class="pledging-msg">
                      <span>{{ scope.item.swiftCode || scope.item.bankVo.code}}</span>
                      <span>{{ scope.item.account  }}</span>
                    </div>
                    
                  </div>
                  <span v-if="!bankList || bankList.length == 0" class="no-data-pop">暂无数据，可点击左侧”+“进行新增</span>
                </template>
            </ab-select>
            </el-form-item>
          </el-col>
          <el-col
            :span="8"
            class="account"
          >
            <span>SWIFT/联行号</span>
            <div class="number">{{ dataForm.paymentAppVo.swiftCode || dataForm.paymentAppVo.revBankCode }}</div>
          </el-col>
          <el-col
            :span="8"
            class="account"
          >
            <span>银行账号</span>
            <div class="number">{{ $filters.formatBankAccount(dataForm.paymentAppVo.revBankAccount) }}</div>
          </el-col>

          <el-col :span="8">
            <el-form-item label="手续承担" prop="feeBearer">
                <el-select
                    class="full_width"
                    size="mini"
                    v-model="dataForm.paymentAppVo.feeBearer"
                    @change="handlerFeeBearer"
                >
                    <el-option
                        v-for="(option, idx) in feeBearerOptions"
                        :key="idx"
                        :label="option.desc"
                        :value="option.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item
              prop="paymentAppVo.remark"
              label="银行备注"
            >
              <el-input
                v-model="dataForm.paymentAppVo.remark"
                placeholder="需体现在银行付款水单上的备注，限23个字符，含符号"
                class="input-with-select"
                maxlength="23"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <div class="ordersInfo">
        <div class="title">订单信息</div>
        <el-table
          class="order-table"
          :data="dataForm.paymentAppPayVoList"
          stripe
          border
        >
          <el-table-column type="index" label="序号" width="55" align="center" />
          <el-table-column prop="billDate" label="订单日期" min-width="120" show-overflow-tooltip />
          <el-table-column prop="clientBillNumber" label="订单编号" min-width="180" show-overflow-tooltip />
          <el-table-column prop="supplierName" label="供应商" min-width="200" show-overflow-tooltip />
          <el-table-column prop="expenseItemIdDesc" label="计费项目" min-width="100" show-overflow-tooltip />
          <el-table-column class-name="edit-cell" min-width="120" show-overflow-tooltip>
            <template #header>
              <span ref="applyAmount">本次申请金额</span>
            </template>
            <template #default="scope">
              <el-form-item
                :prop="'paymentAppPayVoList.' + scope.$index + '.applyAmount'"
                :rules="rules.applyAmount"
              >
                <el-input
                  v-model="scope.row.applyAmount"
                  @change="tableApplyAmountChange($event, scope.row)"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="可付金额" min-width="120" align="right" show-overflow-tooltip>
            <template #default="scope">
              {{ $filters.formatMoney(scope.row.prePaymentAmount) }}
            </template>
          </el-table-column>
          <el-table-column label="订单金额" min-width="120" align="right" show-overflow-tooltip>
            <template #default="scope">
              {{ $filters.formatMoney(scope.row.entrustAmount) }}
            </template>
          </el-table-column>
          <el-table-column prop="currencyIdDesc" label="币别" min-width="100" show-overflow-tooltip />
          <el-table-column v-if="dataForm.paymentAppVo.billType === 1 || (dataForm.paymentAppVo.billType === 2 && dataForm.paymentAppPayVoList && dataForm.paymentAppPayVoList.length > 1)" fixed="right" label="操作" width="80" align="center">
            <template #default="scope">
              <el-button
                style="color:#FF0000"
                type="primary"
                link
                @click="removeRow(scope.row, scope.$index)"
              >删除</el-button>
            </template>
          </el-table-column>

          <template v-if="dataForm.paymentAppVo.billType === 1" #append>
            <div class="add-row" >
              <span @click="addTabItem">
                <ab-svg name="add"></ab-svg> 新增一行
              </span>
            </div>
          </template>
        </el-table>

        <div class="remark">
          <el-form-item
            prop="paymentAppVo.remarkPreClient"
            label="备注"
            :rules="[
              {
                required: requiredRemark,
                message: ['03', '04', '06'].includes(this.dataForm.paymentAppVo.bizType) ? '请在备注栏填写预计出口日期与客户销售订单号' : '请在备注栏填写预计进口日期和与供应商采购订单号',
                trigger: 'change',
              }, // 当确认时，付款明细不存在订单，必填
              { max: 256, message: '最长支持256位字符', trigger: 'blur' }
            ]"
          >
            <el-input
              v-model="dataForm.paymentAppVo.remarkPreClient"
              type="textarea"
              :autosize="{ maxRows: 15 }"
              resize="none"
              placeholder="请输入备注"
            />
          </el-form-item>
        </div>
      </div>
    </el-form>

    <!-- 字段释义 -->
    <!-- 收款方 -->
    <el-popover
      :virtual-ref="$refs.revIdDesc"
      popper-class="form-pop"
      width="500"
      trigger="hover"
      placement="top-start"
      virtual-triggering
      content="收款方需保持和订单的供应商一致,若要用其他收款方，需勾选【委托收款】,并提供《委托授权书》"
    ></el-popover>

    <!-- 汇率 -->
    <el-popover
      :virtual-ref="$refs.settleRate"
      popper-class="form-pop"
      width="200"
      trigger="hover"
      placement="top-start"
      virtual-triggering
      content="中行牌价9:30外汇卖出价"
    ></el-popover>

    <!-- 委托收款 -->
    <el-popover
      :virtual-ref="$refs.disableUnitId"
      popper-class="form-pop"
      width="280"
      trigger="hover"
      placement="top-start"
      virtual-triggering
      content="非订单的供应商作为收款方才需选“是”"
    ></el-popover>

    <!-- 银行备注 -->
    <el-popover
      :virtual-ref="$refs.remark"
      popper-class="form-pop"
      width="200"
      trigger="hover"
      placement="top-start"
      virtual-triggering
      content="体现到银行回单上的备注"
    ></el-popover>

    <!-- 本次申请金额 -->
    <el-popover
      :virtual-ref="$refs.applyAmount"
      popper-class="form-pop"
      width="200"
      trigger="hover"
      placement="top-start"
      virtual-triggering
      content="本单本次付款金额"
    ></el-popover>

    <!-- 新增收款方（供应商） -->
    <el-dialog
      :title="supplierDialog.title"
      v-model="supplierDialog.show"
      top="5vh"
      width="800px"
      class="no-min-height"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :close="closeSupplierDialog"
    >
      <el-form
        :model="supplierDialog"
        :rules="supplierDialog.rules"
        ref="supplierDialog"
        label-position="top"
      >
        <el-row :gutter="25">
          <el-col :span="24">
            <el-form-item
              label="供应商全称"
              prop="name"
              style="margin-bottom: 20px"
            >
              <ab-select
                url="/bas/client/basSupplier/listByName"
                inputKey="name"
                isNotClear
                placeholder="请输入英文名称，如有括号，请采用英文输入法下的括号"
                @handleSelect="supplierNameSelect"
                v-model="supplierDialog.name"
                :urlData="{ name: supplierDialog.name, pageNum: 1, pageSize: 10, isEnabled: 1 }"
              ></ab-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-row :gutter="25">
              <el-col :span="12">
                <el-form-item
                  label="注册地址"
                  prop="address"
                >
                  <el-input
                    size="mini"
                    maxLength='200'
                    v-model="supplierDialog.address"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="区域"
                  prop="areaIdDesc"
                >
                  <ab-address
                    v-model="supplierDialog.areaIdDesc"
                    @change="areaChange"
                  ></ab-address>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            type="primary"
            :loading="supplierDialog.btnLoading"
            @click="confirmSupplierDialog"
          >确定</el-button>
          <el-button @click="closeSupplierDialog">取消</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 新增银行账号 -->
    <ab-account-dialog
      :dialog="bankDialog"
      :account="bankDialog.account"
      :isDefault="1"
      @on-reload="confirmRevBankAdd"
    ></ab-account-dialog>

    <pay-table-dialog
      :dialog="payTableDialog"
      :paymentAppVo="dataForm.paymentAppVo"
      @on-confirm="changeTableData"
    ></pay-table-dialog>
  </div>
  <el-dialog
      v-model="showBizTypePop"
      title="发票类型"
      class="bizType-dialog"
      append-to-body
      width="512px"
      :before-close="bizTypeClose"
  >
  <div>
      <div class="org-item" @click="chenckedType(obj.value)" :class="{'isActived': invockType == obj.value}" v-for="(obj, idx) in bizTypeList" :key="idx">
          <div class="org-tel">
              <el-icon><ArrowDownBold /></el-icon>
          </div>
          <div class="org-name">{{obj.label}}</div>
      </div>
  </div>
  <template #footer>
      <span class="dialog-footer">
          <el-button @click="bizTypeClose">取消</el-button>
          <el-button type="primary" @click="setBizType">
          确定
          </el-button>
      </span>
  </template>
</el-dialog>
</template>

<script>
import payTableDialog from './pledging-payment-detail-payTable-dialog'
import calculation from '@/utils/calculation'
export default {
  components: {
    payTableDialog
  },

  props: {
    routeQuery: {
      type: Object,
      default () {
        return {}
      }
    },

    options: {
      type: Object,
      default () {
        return {}
      }
    },

    dataForm: {
      type: Object,
      default () {
        return {}
      }
    },

    linkParames: {
      type: Object,
      default () {
        return {}
      }
    },
  
    requiredRemark: { // 备注是否必选
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showBizTypePop: false,
      invockType: '',
      bizTypeList: [],
      bankList: [],
      rules: {
        paymentAppVo: {
          revIdDesc: [
            { required: true, message: '请选择收款方', trigger: 'change' }
          ],
          applyAmount: [
            { required: true, message: '请输入收款金额', trigger: 'blur' },
            {
              pattern: /^\d{1,12}(\.\d{1,2})?$/,
              message: '最长支持12位整数，2位小数',
              trigger: 'blur',
            },
            { validator: (rule, value, callback) => {
              if (value) {
                if (this.dataForm.paymentAppPayVoList && this.dataForm.paymentAppPayVoList.length) {
                  let prePaymentAmount = 0
                  this.dataForm.paymentAppPayVoList.map(e => {
                    if (e.prePaymentAmount) {
                      prePaymentAmount = calculation.add(prePaymentAmount, e.prePaymentAmount)
                    }
                  })
                  if (this.dataForm.paymentAppVo.applyAmount > prePaymentAmount) {
                    callback(new Error('申请金额不可超过订单可付金额！'))
                  } else {
                    callback()
                  }
                } else {
                  callback()
                }
              }
            }, trigger: 'blur' }
          ],
          applyCurrencyIdDesc: [
            { required: true, message: '请选择收款币别', trigger: 'change' }
          ],
          revBankIdDesc: [
            { required: true, message: '请选择收款银行', trigger: 'change' }
          ],
          remark: [
            {
              pattern: /^((?!:|"|%|&|\*|<|>|@|#|\^|~|\[|\]|\|).)*$/,
              message: '不能输入"%&*<>@#~^[]|',
              trigger: ['change', 'blur'],
            }
          ]
        },
        applyAmount: [
          { required: true, message: '请输入本次申请金额', trigger: 'blur' },
          {
            pattern: /^\d{1,12}(\.\d{1,2})?$/,
            message: '最长支持12位整数，2位小数',
            trigger: 'blur',
          }
        ]
      },
      columns: [
        {
          props: 'materielNumber',
          labels: '订单日期',
          widths: 100
        },
        {
          props: 'createTime',
          labels: '订单编号',
          widths: 100
        },
        {
          props: 'classifyStatusDesc',
          labels: '供应商',
          widths: 100
        },
        {
          props: 'itemCode',
          labels: '计费项目',
          widths: 100
        },
        {
          props: 'brandName',
          labels: '本次申请金额',
          widths: 100,
          type: 'money'
        },
        {
          props: 'itemName',
          labels: '可付金额',
          widths: 100,
          type: 'money'
        },

        {
          props: 'clientNumber',
          labels: '订单金额',
          widths: 100,
          type: 'money'
        },
        {
          props: 'itemUnitName',
          labels: '币别',
          widths: 100
        }
      ],
      tableData: [],
      // 收款方（供应商）弹框
      supplierDialog: {
        title: '新增供应商',
        show: false,
        btnLoading: false,
        rules: {
          name: [
            { required: true, message: '请选择供应商全称', trigger: 'blur' },
            { max: 100, message: '最大长度100个字符', trigger: 'change' },
            {
              validator: (rule, value, callback) => {
                if (
                  !/^((?!:|"|%|&|\*|（|）|<|>|@|#|\^|~|\[|\]|\|).)*$/.test(
                    value
                  )
                ) {
                  callback(
                    new Error(
                      '请录入英文名称，如有括号，请用英文输入法下的括号，请不要输入下列符号："%&*<>@#~^[]|'
                    )
                  )
                }
                if (!/^[a-z\s()\.\-\/\\\,0-9']+$/i.test(value)) {
                  callback(new Error('请输入英文名称'))
                }
                callback()
              },
              trigger: 'blur'
            }
          ],
          address: [
            { required: true, message: '请输入注册地址', trigger: 'blur' }
          ],
          areaIdDesc: [
            { required: true, message: '请选择区域', trigger: 'blur' }
          ]
        }
      },
      // 银行账号弹框
      bankDialog: {
        show: false,
        account: {}
      },
      // 待付汇弹框
      payTableDialog: {
        show: false,
        data: {}
      },
       // 委托方是否由垫资订单
        hasAdvance: null,
      //手续费列表
      feeBearerOptions: []
    }
  },

  watch: {
    'dataForm.paymentAppPayVoList': {
      handler(array) {
        if (array && array.length) {
          let applyAmount = 0
            array.map((row, idx) => {
            if (['03', '04', '06'].includes(this.dataForm.paymentAppVo.bizType)) {
              if (row.cashDirection === 2) {
                applyAmount = this.$calc.add(
                  applyAmount,
                  this.$calc.mul(row.applyAmount, this.dataForm.paymentAppVo.settleRate || 0)
                )
              } else {
                applyAmount = this.$calc.sub(applyAmount, row.applyAmount)
              }
            } else if (['01', '02'].includes(this.dataForm.paymentAppVo.bizType)) {
              applyAmount = this.$calc.add(row.applyAmount || 0, applyAmount)
              if (idx === 0) {
                this.dataForm.paymentAppVo.applyCurrencyIdDesc = row.currencyIdDesc
                this.dataForm.paymentAppVo.applyCurrencyId = row.currencyId
              }
              // if (!this.dataForm.paymentAppVo.id) {
              //   this.queryRate()
              // }
            }
          })
          this.dataForm.paymentAppVo.applyAmount = applyAmount.toFixed(2)
        }
      },
      deep: true,
    },

    // 监听备注是否必填
    requiredRemark(val) {
      this.$nextTick(() => {
        if (val) {
          this.$refs.dataForm.validateField('paymentAppVo.remarkPreClient').catch(err => {})
        } else {
          this.$refs.dataForm.clearValidate('paymentAppVo.remarkPreClient')
        }
      })
    }
  },

  computed: {
    settlementAmount() {
      let amount = 0
      if (this.dataForm.paymentAppVo.applyAmount) {
        if (['03', '04', '06'].includes(this.dataForm.paymentAppVo.bizType)) {
          amount = this.dataForm.paymentAppVo.applyAmount / this.dataForm.paymentAppVo.settleRate
        } else {
          amount = this.dataForm.paymentAppVo.applyAmount * this.dataForm.paymentAppVo.settleRate
        }
      }
      return amount ? Number(amount).toFixed(2) : 0
    }
  },

  mounted() {
    this.getPremiumList()
  },

  methods: {
    getPremiumList(){
        this.$get('/sms/client/paymentApp/getSelect').then(({ data }) => {
            if (data.code === 'C0000') {
                this.feeBearerOptions = data.result.feeBearer || []
            }
        })
    },
    handlerFeeBearer(val){
        if (val == 2) {
            this.dataForm.paymentAppVo.chargesBearerCny = 0
        } else {
            this.$post('/sms/client/paymentApp/getChargesBearer', this.dataForm.paymentAppVo).then(({ data }) => {
                if (data && data.code === 'C0000' && data.result) {
                    this.dataForm.paymentAppVo.chargesBearerCny = data.result.chargesBearerCny
                    this.dataForm.paymentAppVo.chargesCurrencyCny = data.result.chargesCurrencyCny
                    this.dataForm.paymentAppVo.chargesBearer = data.result.chargesBearer
                    this.dataForm.paymentAppVo.chargesCurrencyId = data.result.chargesCurrencyId
                    this.dataForm.paymentAppVo.chargesCurrencyIdDesc = data.result.chargesCurrencyIdDesc
                }
            })
        }
    },
    // 通过协议查找业务类型
    getBizTypeList() {
      const principalId = this.linkParames.principalId ? this.linkParames.principalId : ''
      this.$get('/sms/client/paymentApp/getBizType', {
        principalId
      }).then(({ data }) => {
        if (data.code === 'C0000') {
          let bizTypeList = []
          data.result.forEach(row => {
            row.label = row.value === '01' ? '13% 增值税专用发票' : '海关税票+6%服务费发票'
            if (!bizTypeList.find(e => e.label === row.label)) {
              bizTypeList.push(row)
            }
          })
          this.bizTypeList = bizTypeList
          if ([undefined, 'add'].includes(this.routeQuery.action) && !this.dataForm.paymentAppVo.id) { // 新增设置默认值
            let defaultBiztype = this.bizTypeList.find(e => e.value === '02') // 多个默认代理进口
            if (!defaultBiztype && this.bizTypeList.length === 1) { // 仅有一条
              defaultBiztype = this.bizTypeList[0]
            }
            this.dataForm.paymentAppVo.bizType = defaultBiztype ? defaultBiztype.value : ''
          }
          this.bizTypeChange()
        }
      })
    },

    // 修改业务类型弹框
    editBizType() {
      if (this.bizTypeList.length > 1) {
        this.invockType = this.dataForm.paymentAppVo.bizType
        this.showBizTypePop = true
      }
    },

    // 设置业务类型
    setBizType() {
      console.log(this.invockType)
      this.dataForm.paymentAppVo.bizType = this.invockType
      this.showBizTypePop = false
      this.bizTypeChange()
    },
    bizTypeClose () {
      this.showBizTypePop = false
    },

    // 变更业务类型
    bizTypeChange() {
      if ([undefined, 'add'].includes(this.routeQuery.action) && !this.dataForm.paymentAppVo.id) { // 新增设置默认值
        // 清空订单明细表
        this.dataForm.paymentAppPayVoList = []
        // 默认币别设置
        if (['01', '02'].includes(this.dataForm.paymentAppVo.bizType)) { // 进口
          // 结算汇率币别美元
          this.dataForm.paymentAppVo.settleCurrencyId = '1990085864259584'
          this.dataForm.paymentAppVo.settleCurrencyIdDesc = '人民币'
          this.dataForm.paymentAppVo.settleCurrencyNumber = 'CNY'
          // 申请金额币别 默认人民币
          this.dataForm.paymentAppVo.applyCurrencyId = '1990091737661440'
          this.dataForm.paymentAppVo.applyCurrencyIdDesc = '美元'
        } else if (['03', '04', '06'].includes(this.dataForm.paymentAppVo.bizType)) { // 出口
          // 结算汇率币别美元
          this.dataForm.paymentAppVo.settleCurrencyId = '1990091737661440'
          this.dataForm.paymentAppVo.settleCurrencyIdDesc = '美元'
          this.dataForm.paymentAppVo.settleCurrencyNumber = 'USD'
          //  申请金额币别 默认人民币
          this.dataForm.paymentAppVo.applyCurrencyId = '1990085864259584'
          this.dataForm.paymentAppVo.applyCurrencyIdDesc = '人民币'
        }
      }
      if (!this.dataForm.paymentAppVo.id) { // 新增或其它地方引入（非列表进入）
        this.queryRate()
      }
      // 检查销售订单附件是否必传
      this.$parent.saleAttachFileCheck()
      // 获取垫资情况及电子签状态
      this.checkEsignFlow()
    },

    // 查询汇率
    queryRate() {
      if (this.dataForm.paymentAppVo.bizType && this.dataForm.paymentAppVo.applyCurrencyId && this.dataForm.paymentAppVo.paymentType) {
        this.dataForm.paymentAppVo.settleRate = ''
        this.$post('/sms/client/paymentApp/getSettleRate', {
          paymentAppVo: this.dataForm.paymentAppVo,
          paymentAppRevVoList: this.dataForm.paymentAppRevVoList,
        }).then(({ data }) => {
          if (data.code === 'C0000') {
            this.dataForm.paymentAppVo.settleRate = data.result
          }
        })
      }
    },

    // 获取垫资情况及电子签状态
    checkEsignFlow() {
      if (this.dataForm.paymentAppVo.bizType) {
        this.$post('/sms/client/paymentApp/checkEsignFlow', this.dataForm.paymentAppVo).then(({ data }) => {
          if (data.code === 'C0000') {
            // 是否垫资
            this.hasAdvance = data.result.hasAdvance
            if (!this.dataForm.paymentAppVo.id && !data.result.hasAdvance) {
              this.dataForm.paymentAppVo.isAdvance = false
            }
            // 手续费承担方
            if ([undefined, 'add'].includes(this.routeQuery.action) && data.result.feeBearer) { // 新增设置默认值
              this.dataForm.paymentAppVo.feeBearer = data.result.feeBearer
            }
            if (!this.dataForm.paymentAppVo.feeBearer) {
              this.dataForm.paymentAppVo.feeBearer = data.result.feeBearer || 1
            }
            // 收款方
            if (!this.dataForm.paymentAppVo.revId && !this.dataForm.paymentAppVo.revIdDesc && data.result.revId) {
              this.dataForm.paymentAppVo.revId = data.result.revId
              this.dataForm.paymentAppVo.revIdDesc = data.result.revIdDesc
              this.getBankList()
            }
            // 获取协议手续费金额
            this.getChargesBearer()
          }
        })
      }
    },
    
    // 获取协议手续费金额
    getChargesBearer () {
      if (!this.dataForm.paymentAppVo.id) {
        this.$post('/sms/client/paymentApp/getChargesBearer', this.dataForm.paymentAppVo).then(({ data }) => {
          if (data && data.code === 'C0000' && data.result) {
            this.dataForm.paymentAppVo.chargesBearerCny = data.result.chargesBearerCny
            this.dataForm.paymentAppVo.chargesCurrencyCny = data.result.chargesCurrencyCny
            this.dataForm.paymentAppVo.chargesBearer = data.result.chargesBearer
            this.dataForm.paymentAppVo.chargesCurrencyId = data.result.chargesCurrencyId
            this.dataForm.paymentAppVo.chargesCurrencyIdDesc = data.result.chargesCurrencyIdDesc
            this.dataForm.paymentAppVo.chargesRate = data.result.chargesRate
          }
        })
      }
    },

    // 自动分摊 & 查询收款账号
    amoutOrRevChange() {
      if (!['wait', 'import', 'out'].includes(this.routeQuery.action)) {
        if (this.dataForm.paymentAppVo.applyAmount && this.dataForm.paymentAppVo.applyCurrencyId) {
          this.$post('/sms/client/paymentApp/autoApplyAmount', {
            paymentAppVo:  this.dataForm.paymentAppVo,
            paymentAppPayVoList: this.dataForm.paymentAppPayVoList
          }).then(({ data }) => {
            if (data.code === 'C0000') {
              this.dataForm.paymentAppPayVoList = data.result.paymentAppPayVoList
              this.$emit('payList-change', array)
            }
          })
          this.$post('/sms/client/paymentApp/queryRevBank', this.dataForm.paymentAppVo).then(({ data }) => {
            if (data.code === 'C0000') {
              this.dataForm.paymentAppVo.zxAccountNumber = data.result.zxAccountNumber
              this.dataForm.paymentAppVo.zxBankAccountId = data.result.zxBankAccountId
              this.dataForm.paymentAppVo.zxCompanyId = data.result.zxCompanyId
              this.dataForm.paymentAppVo.zxCompanyName = data.result.zxCompanyName
              this.dataForm.paymentAppVo.zxName = data.result.zxName
            }
          })
        }
      }
    },

    // 收款方选择
    revSelect(row) {
      if (!row) {
        this.dataForm.paymentAppVo.revId = ''
        this.dataForm.paymentAppVo.revBankId = ''
        this.dataForm.paymentAppVo.revBankIdDesc = ''
        this.dataForm.paymentAppVo.revBankAccount = ''
        this.dataForm.paymentAppVo.swiftCode = ''
        this.dataForm.paymentAppVo.revBankCode = ''
      } else {
        this.dataForm.paymentAppVo.revId = row.id
      }
      this.getBankList()
    },

    // 收款方新增
    revAdd() {
      this.supplierDialog.show = true
    },

    // 关闭收款方弹框
    closeSupplierDialog() {
      this.supplierDialog.show = false
    },

    // 收款方弹框确认
    confirmSupplierDialog() {
      this.$refs.supplierDialog.validate((valid) => {
        if (valid) {
          this.supplierDialog.btnLoading = true
          this.$post('/bas/client/basSupplier/save', {
            name: this.supplierDialog.name,
            address: this.supplierDialog.address,
            areaId: this.supplierDialog.areaId,
            supplierId: this.supplierDialog.supplierId,
            shortName: this.supplierDialog.name.substring(0, this.supplierDialog.name.indexOf(' ') != -1 ? this.supplierDialog.name.indexOf(' ') : this.supplierDialog.name.length),
            status: 2
          }).then(({ data }) => {
            if (data && data.code == 'C0000') {
              this.dataForm.paymentAppVo.revId = data.result
              this.dataForm.paymentAppVo.revIdDesc = this.supplierDialog.name
              this.getBankList()
              this.amoutOrRevChange()
              this.closeSupplierDialog()
            }
          }).finally(() => {
            this.supplierDialog.btnLoading = false
          })
        }
      })
    },

    // 选择供应商
    supplierNameSelect(row) {
      this.supplierDialog.address = row.address
      this.supplierDialog.areaIdDesc.row.areaIdDesc || []
      this.supplierDialog.name = row.name
      this.supplierDialog.supplierId = row.id
      this.$refs.supplierDialog.validateField('name')
      this.amoutOrRevChange()
    },

    // 选择区域
    areaChange(areaId, areaList) {
      this.supplierDialog.areaList = areaList || []
      this.supplierDialog.areaId = areaId.join(',')
    },

    // 币别
    applyCurrencySelect(row) {
      if (row && row.id) {
        this.dataForm.paymentAppVo.applyCurrencyId = row.id
      } else {
        this.dataForm.paymentAppVo.applyCurrencyId = ''
      }
      this.queryRate()
      this.amoutOrRevChange()
    },

    // 收款银行列表
    getBankList(initFlag) {
      if (this.dataForm.paymentAppVo.revId) {
        this.$get('/sms/client/paymentApp/getSupplier', {
          revId: this.dataForm.paymentAppVo.revId,
        }).then(({ data }) => {
          if (data && data.code === 'C0000') {
            this.bankList = data.result.supplierAccountList
            this.bankList.map(e => {
              e.value = e.bankName
            })
            // 设置默认值
            if (!initFlag) {
              let defaultBank = this.bankList.find(e => !!e.isDefault) // 有默认银行
              if (!defaultBank && this.bankList.length === 1) { // 仅有一条
                defaultBank = this.bankList[0]
              }
              this.dataForm.paymentAppVo.revBankId = defaultBank ? defaultBank.bank : ''
              this.revBankChange(defaultBank ? defaultBank: '')
            }
          }
        })
      } else {
        this.bankList = []
      }
    },

    // 收款银行变更
    revBankChange(value) {
      if (value) {
        let bankData = ''
        if (typeof value === 'string') {
          bankData = this.bankList.find(e => e.bank === value)
        } else {
          bankData = value
        }
        this.dataForm.paymentAppVo.revBankId = bankData.bank
        this.dataForm.paymentAppVo.revBankIdDesc = bankData.bankName
        this.dataForm.paymentAppVo.revBankAccount = bankData.account
        this.dataForm.paymentAppVo.swiftCode = bankData.swiftCode
        this.dataForm.paymentAppVo.revBankCode = bankData.bankVo ? bankData.bankVo.code : ''

      } else {
        this.dataForm.paymentAppVo.revBankId = ''
        this.dataForm.paymentAppVo.revBankIdDesc = ''
        this.dataForm.paymentAppVo.revBankAccount = ''
        this.dataForm.paymentAppVo.swiftCode = ''
        this.dataForm.paymentAppVo.revBankCode = ''
      }
    },

    // 收款银行新增
    revBankAdd() {
      this.bankDialog.account.parentId = this.dataForm.paymentAppVo.revId
      this.bankDialog.account.accountName = this.dataForm.paymentAppVo.revIdDesc
      this.bankDialog.account.sourceBillId = this.dataForm.paymentAppVo.revId
      this.bankDialog.show = true
    },

    // 收款银行新增确认
    confirmRevBankAdd(result) {
      if(result && result.form && result.form.bank) {
        this.$get('/sms/client/paymentApp/getSupplier', {
          revId: this.dataForm.paymentAppVo.revId,
        }).then(({ data }) => {
          if (data && data.code === 'C0000') {
            this.bankList = data.result.supplierAccountList
            if (result.form.isDefault) {
              this.bankList.map(e => {
                console.log(e.id, result.form.bank)
                if (e.id == result.form.bank) {
                  result.form.bank = e.bank
                }
              })
            }
            this.dataForm.paymentAppVo.revBankId = result.form.bank
            this.revBankChange(result.form.bank)
          }
        })
      }
    },

    // 引入订单
    addTabItem() {
      if (!this.dataForm.paymentAppVo.revId) {
        return this.$message({
          type: 'error',
          message: '请先选择收款方',
          offset: 380,
          grouping: true
        })
      }
      this.payTableDialog.data.unitId = this.dataForm.paymentAppVo.revId
      this.payTableDialog.data.unitIdDesc = this.dataForm.paymentAppVo.revIdDesc
      this.payTableDialog.data.trusteeId = this.dataForm.paymentAppVo.trusteeId
      this.payTableDialog.data.paymentType = this.dataForm.paymentAppVo.paymentType
      this.payTableDialog.data.bizType = this.dataForm.paymentAppVo.bizType
      this.payTableDialog.data.bizTypeDesc = this.dataForm.paymentAppVo.bizTypeDesc
      this.payTableDialog.data.isAdvance = this.dataForm.paymentAppVo.isAdvance
      this.payTableDialog.data.coreBillIds = this.dataForm.paymentAppPayVoList.map(row => row.coreBillId)
      this.payTableDialog.data.costPoolIds = this.dataForm.paymentAppPayVoList.map(row => row.costPoolIds)
      this.payTableDialog.data.disableUnitId = this.dataForm.paymentAppVo.disableUnitId
      this.payTableDialog.show = true
    },

    // 本次申请金额
    tableApplyAmountChange(value, row) {
      row.applyAmountFormat = this.$filters.formatMoney(value, true)
    },

    // 删除分录
    removeRow(row, index) {
      this.$confirm(`是否删除该行?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (row.id) {
          this.$get('/sms/client/paymentApp/deletePayInfo', { id: row.id }).then(({ data }) => {
            if (data.code === 'C0000') {
              this.$message({
                type: 'success',
                message: data.message,
                offset: 380,
                grouping: true
              })
              this.$emit('reload')
            }
          })
        } else {
          this.dataForm.paymentAppPayVoList.splice(index, 1)
          this.$emit('payList-change', array)
        }
      }).catch(() => {})
    },

    // 选择确认
    changeTableData(array) {
      array.map(row => {
        row.applyAmountFormat = this.$filters.formatMoney(row.applyAmount, true)
        this.dataForm.paymentAppPayVoList.push(row)
      })
      this.$emit('payList-change', array)
    },
    chenckedType (type) {
      this.invockType = type
    }

  }
}
</script>

<style lang='scss'>
.paymentApplication {
  text-align: left;
  border-top: 1px solid #f0f2f5;
  color: #000000;
  .el-form-item__label {
    color: #000000;
    font-size: 14px;
  }
  .choose{
    height: calc(100% - 30px);
    border-bottom: 1px solid #F0F2F5;
    padding-top: 16px;
  }
  .biz-type {
    height: 35px;
    line-height: 35px;
    background-color: #F2F7FF;
    border-radius: 0 0 8% 8%;
    width: 270px;
    text-align: center;
    cursor: pointer;
    .icon-svg {
      vertical-align: middle;
      width: 14px;
      height: 14px;
    }
  }
  .payoutInfo {
    margin-top: 25px;
    padding-bottom: 5px;
    border-bottom: 1px solid #f0f2f5;
    .title {
      font-size: 18px;
      margin-bottom: 20px;
    }
    .merge-input {
      > .el-col {
        margin-bottom: 0;
      }
    }
    .revIdDesc {
      .el-input__inner {
        --el-disabled-text-color: #000;
      }
    }
    .recipient {
      width: 100%;
      display: flex;
      padding: 0 0 20px;
      border-bottom: 1px solid #f0f2f5;
      line-height: 24px;
      .supplier {
        padding: 5px 12px;
        height: 24px;
        line-height: 14px;
        border-radius: 4px;
        background-color: #f0f2f5;
        span {
          color: #fe2424;
        }
      }
      .icon-svg {
        width: 24px;
        height: 24px;
        vertical-align: middle;
        margin: 0 10px;
        cursor: pointer;
      }
      p {
        font-size: 22px;
        font-weight: bold;
      }
    }
    .input-with-select {
      .select {
        width: 130px;
        background-color: #f0f2f5;
        border-radius: 0 8px 8px 0;
        .el-input__wrapper {
          box-shadow: none;
        }
      }
    }
    .applyAmount-input{
      font-family: DIN_Condensed_Bold;
      color: #000 !important;
    }
    .el-col {
      margin-bottom: 5px;
    }
    .collectionMoneyDelete {
      display: flex;
      font-size: 14px;
      .symbol1 {
        margin: 53px 20px 0 0;
        color: #7f7f7f;
      }
      .symbol3 {
        margin: 53px 20px 0;
        color: #7f7f7f;
      }
      .symbol4 {
         margin: 45px 30px 0 30px;
        color: #7f7f7f;
        font-size: 20px;
        font-weight: 500;
      }
      .rate {
        .number {
          font-size: 30px;
          color: #f87243;
          margin-top: 19px;
          font-weight: 500;
        }
      }
      .symbol2 {
        margin: 45px 20px 0 40px;
        color: #7f7f7f;
        font-size: 20px;
        font-weight: 500;
      }
      .zong {
        .number {
          font-size: 36px;
          color: #f87243;
          margin-top: 14px;
          font-weight: 500;
          span {
            font-size: 14px;
            font-weight: 500;
          }
        }
      }
    }
    .addBank {
      line-height: 100%;
      .icon-svg {
        width: 24px;
        height: 24px;
      }
    }
    .account {
      font-size: 14px;
      div {
        font-size: 36px;
        color: #f87243;
        font-weight: 500;
        margin-top: 15px;
      }
    }
  }
  .ordersInfo {
    margin-top: 36px;
    .title {
      font-size: 18px;
      margin-bottom: 37px;
    }
    .remark {
      margin: 35px 0 38px;
      .el-textarea {
        .el-textarea__inner {
          min-height: 43px !important;
          padding-top: 10px;
          color: #000;
          line-height: 23px;
        }
      }
    }
    .add-row{
      width: 100%;
      height: 45px;
      padding-left: 22px;
      background-color: #F2F7FF;
      text-align: left;
      font-size: 14px;
      line-height: 45px;
      span {
        cursor: pointer;
        .icon-svg{
          width: 24px;
          height: 24px;
          vertical-align: middle;
        }
      }
    }
  }
  .order-table {
    .el-table__body-wrapper {
      .edit-cell {
        padding: 0;
        .cell {
          padding: 0 5px;
          .el-form-item {
            margin-bottom: 0;
            .el-input__wrapper {
              background: #fff;
            }
          }
        }
      }
    }
  }

  .footer {
    margin: 20px;
    text-align: center;
  }
  .no-data-pop {
    color:#999999;text-align: center;
  }
  .no-data-pop:hover {
    color:#ffffff;
  }
  
}

.pledging-bank-item {
  line-height: 1.5;
  padding: 5px 0;
  .pledging-msg {
    display: flex;
    justify-content: space-between;
    opacity: 0.6;
    font-size: 14px;
    &:hover {
      opacity: 1;
    }
  }
  &:hover {
    .pledging-msg {
      opacity: 1;
    }
    opacity: 1;
  }
  
}

.jw-order-edit {
  .biz-btn {
    text-align: right;
  }
  .edit-radio {
    width: 100%;
  }
  .ml-4 {
    margin: 10px
  }
}
.bizType-dialog {
    .el-dialog__footer {
        text-align: center;
        padding-top: 0;
    }
    .el-dialog__body {
        padding: 40px;
    }
    .org-item {
        width: 100%;
        height: 60px;
        border-radius: 15px;
        position: relative;
        border: 2px solid #EEEEEE;
        margin-bottom: 20px;
        cursor: pointer;
        &.isActived {
            border: 2px solid #0a7cff;
            .org-tel {
                background-color: #0a7cff;
            }
        }
        .org-tel {
            width: 37px;
            height: 36px;
            background-color: #EEEEEE;
            color: #ffffff;
            border-radius: 15px 0 15px 0;
            position: absolute;
            cursor: pointer;
            top: -2px;
            left: -2px;
            .el-icon {
                margin: 12px;
                width: 12px;
                height: 8px;
                font-weight: bold;
            }
        }
        .org-name {
            font-size: 16px;
        }
        div:last-child {
            text-align: center;
            line-height: 60px;
        }

    }
   

}
</style>
